import { lazy } from 'react';

import { type RouteComponentProps } from 'react-router'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import { useAppRoutes } from '@webapp/hooks/useAppRoutes'
import { type PayRequestApproval } from '@webapp/models/PayRequest'
import messages from './messages'
import { SpendingCardApprovalListPageTabs } from './SpendingCardApprovalListPage'

export interface SpendingCardApproveFundRequestPageParams {
  uuid: PayRequestApproval['uuid']
}

const SpendingCardApproveFundRequestViewChunk = lazy(() =>
  import('../containers/SpendingCardApproveFundRequestView').then(
    ({ SpendingCardApproveFundRequestView }) => ({
      default: SpendingCardApproveFundRequestView,
    })
  )
)

export const SpendingCardApproveFundRequestPage = (
  props: RouteComponentProps<SpendingCardApproveFundRequestPageParams>
) => {
  const intl = useProcurifyIntl()

  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(
        messages.spendingCardApproveFundRequestPageTitle
      )}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.spendingCardApprovalListPageTitle),
          link: url('SpendingCardApprovalListPage', {
            tab: SpendingCardApprovalListPageTabs.PENDING,
          }),
        },
        {
          name: intl.formatMessage(
            messages.spendingCardApproveFundRequestPageTitle
          ),
        },
      ]}
    >
      <SpendingCardApproveFundRequestViewChunk uuid={props.match.params.uuid} />
    </Page>
  )
}
